export const formFields = [
    {
        label: 'Name',
        name: 'name',
        type: 'text',
        placeholder: 'John Cena', // Updated placeholder for consistency
        required: true,
    },
    // {
    //     label: 'Email',
    //     name: 'email',
    //     type: 'email',
    //     placeholder: 'you@cant-see.me',
    //     required: true,
    // },
    {
        label: 'Subject',
        name: 'subject',
        type: 'text',
        placeholder: 'lets have a coffee',
        required: true, 
    },
    {
        label: 'Message',
        name: 'message',
        type: 'textarea',
        placeholder: 'Tell me everything...',
        rows: 6,
        required: true,
    },
];
